import { FieldSelect } from '@dixa/lib-shared-habla';
import { useCollectionQuery } from 'lib-knowledge-management-common/graphql';
import { usePaginatedCollections } from 'lib-knowledge-management-common/hooks/usePaginatedCollections';

export function CollectionSelect({
  collectionId,
  required,
  label = 'Collection',
  excludeInternalOnly = false,
  setCollectionId,
}: {
  collectionId: string | undefined;
  required?: boolean;
  label?: string;
  excludeInternalOnly?: boolean;
  setCollectionId: (id: string) => void;
}): JSX.Element {
  // Every page, since the search only filters what is loaded
  const { data: collectionsData, loading } = usePaginatedCollections({
    fetchAll: true,
  });

  const selectedCollection = useCollectionQuery({
    skip: !collectionId,
    variables: {
      id: collectionId || '',
    },
  });

  const collections =
    collectionsData?.collections.results
      .filter(({ internalOnly }) => !excludeInternalOnly || !internalOnly)
      .map(({ id, title: name }) => ({
        id,
        name,
      })) || [];

  function onChange(e: string | number | undefined) {
    if (e) {
      setCollectionId(e?.toString());
    }
  }
  return (
    <FieldSelect
      disabled={false}
      searchable
      label={label}
      required={required}
      input={{
        name: selectedCollection.data?.collection?.title || '',
        value: collectionId || '',
        onChange,
      }}
      items={collections}
      loading={loading}
    />
  );
}
